import * as React from 'react';

export default class AboutUs extends React.PureComponent {
  render(): JSX.Element {
    return (
      <section id="extensions" className="extensions feature-header">
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-sm-8 col-xs-12">
              <h2 className="lg-title-2">About us</h2>
              <p>We are a organization that was established in march of 2018 to meet the need in the area of support and empowerment of adolescent girls and young women in Timor-Leste through its EMA-program.
                            </p>
              <p>
                Its board is made up of experienced volunteers in the areas of social work, psychology, education and child protection. Pro-Ema’s founder also founded and directed for 9 years,  another organization which is consider a model in Timor-Leste in the areas of shelter and protection of children victims of violence and sexual abuse.
                            </p>
              <p>Today Pro-Ema employs 16 timorense staff, 10 of them are young women who have survived sexual violence and have lived for more than 5 years in a shelter due to security reasons.
                            </p>
            </div>
            <div className="col-md-4 col-sm-4 col-xs-12">
              <div className="volunteer text-center">
                <img className="img-responsive" src="assets/images/home/volunteers-needed.jpg" alt="volunteer" />
                <h2>Volunteer Needed</h2>
                <h3>Welcome to us</h3>
                <p>Have you always wanted to be part of a meaningful project? Do you love traveling but also want to give back to the local communities?</p>
                <a className="btn btn-join" href="/Volunteering">Join In</a>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AboutUs.tsx